import axios from 'axios';

const manipulateBADevice = (item: {
  name: string;
  text: string;
  group: string;
  type: string;
  value: string;
}) => {
  try {
    const value = item.value == '關閉' ? '開啟' : '關閉';
    const newObj = { ...item, value: value };
    axios('/ezcon/api/ba/frontSetstate', {
      method: 'POST',
      headers: {
        authorization: window.localStorage['feathers-jwt'],
      },
      data: newObj,
    });
  } catch (error) {
    console.error(error);
  }
};

const sendMessage = (
  query: { _id?: string; householdNumbers?: string; firebaseClass: string },
  message: string,
  redirect: string
) => {
  axios.post(
    '/ezcon/api/emitMsgQuery',
    {
      service: 'message',
      event: 'msg',
      title: '充電樁',
      content: message,
      type: 'success',
      class: 'chargingPile',
      duration: 8000,
      redirect,
      query,
    },
    {
      headers: {
        authorization: window.localStorage['feathers-jwt'],
      },
    }
  );
};

export { manipulateBADevice, sendMessage };
